export interface EmailOtpRequestModel {
  email: string;
}
